export enum EServiceOrigin {
  ONBOARDING = 'Onboarding',
  PANEL = 'Panel',
  PAYMENT_LINK = 'PaymentLink'
}
